"use client";

import { AuthProvider } from "@/lib/auth-context";
import { Toaster } from "@/components/ui/sonner";
import { ClientErrorReporter } from "@/components/ClientErrorReporter";

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <AuthProvider>
      <ClientErrorReporter />
      {children}
      <Toaster />
    </AuthProvider>
  );
}
